module.exports = __webpack_public_path__ + "public/img/ttd.ad6324f5.png";